import React, { useState } from "react";
import {
  Button,
  ButtonDropdown,
  Col,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import { CloseIcon, FilterIcon } from "../../assets/images";
import { RadioTypes } from "../../commonTypes/universalTypes";
import { RadioContainer } from "../commons";

type AppProps = {
  attachment: string;
  approved: string;
  settingApproval: (approvalData: string | undefined, setApproval: any) => void;
  settingAttachment: (
    approvalData: string | undefined,
    setApproval: any
  ) => void;
  setClearFilter: (data: boolean) => void;
  setAttachment: React.Dispatch<React.SetStateAction<string>>;
  setApproved: React.Dispatch<React.SetStateAction<string>>;
  setData: any;
  setOffset: React.Dispatch<React.SetStateAction<number>>;
  approvalValue: string;
  attachmentValue: string;
  setApprovalValue: React.Dispatch<React.SetStateAction<string>>;
  setAttachmentValue: React.Dispatch<React.SetStateAction<string>>;
  setApplyFilter: React.Dispatch<React.SetStateAction<boolean>>;
  setDataReset: any;
  resetCount: () => void;
};

export const APPROVAL_RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "1",
    _id: "App_1",
    name: "Approved",
  },
  {
    id: "0",
    _id: "App_0",
    name: "Unapproved",
  },
  {
    id: "2",
    _id: "App_2",
    name: "Approved By Me",
  },
  {
    id: "3",
    _id: "App_3",
    name: "Approved By Others",
  },
];

export const ATTACHMENT_RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "1",
    _id: "Att_1",
    name: "With File Attachment",
  },
  {
    id: "0",
    _id: "Att_0",
    name: "Without File Attachment",
  },
];

const DisbursementFilter = ({
  settingApproval,
  settingAttachment,
  setAttachment,
  setDataReset,
  setApproved,
  setClearFilter,
  setOffset,
  approvalValue,
  attachmentValue,
  setApprovalValue,
  setAttachmentValue,
  resetCount,
  attachment,
  approved,
  setData,
  setApplyFilter,
}: AppProps) => {
  const [toggle, setToggle] = useState<boolean>(false);
  const handleSetApprovalRadioValue = (radioValue: string) => {
    setApprovalValue(radioValue);
  };

  const handleSetAttachmentRadioValue = (radioValue: string) => {
    setAttachmentValue(radioValue);
  };

  const handleSubmit = () => {
    setApplyFilter((prev: boolean) => !prev);
    setOffset(0);
    resetCount();
    setDataReset([]);
    settingApproval(approvalValue, setApproved);
    settingAttachment(attachmentValue, setAttachment);
    setClearFilter(false);
    setData([]);
  };

  const clearFilter = () => {
    setOffset(0);
    setApprovalValue("");
    setAttachmentValue("");
    setAttachment("");
    setApproved("");
    setClearFilter(true);
  };

  const resetFilterData = () => {
    setApprovalValue(approved);
    setAttachmentValue(attachment);
  };

  return (
    <ButtonDropdown
      isOpen={toggle}
      toggle={() => {
        resetFilterData();
        setToggle(!toggle);
      }}
    >
      <DropdownToggle
        caret
        color="secondary"
        style={
          toggle
            ? {
                color: "#dd4433",
                border: "1px solid #dd4433",
                backgroundColor: "#fff6f5",
              }
            : {}
        }
        outline
      >
        <img src={FilterIcon} alt="" />{" "}
        <span className={(approvalValue || attachmentValue) && "filter-count"}>
          <span>
            {approvalValue && attachmentValue
              ? 2
              : approvalValue || attachmentValue
              ? 1
              : ""}
          </span>
        </span>
      </DropdownToggle>

      <DropdownMenu left>
        <div className="download-dropdown p-3">
          <div className="d-flex justify-content-between align-items-center mt-0 mb-0">
            <h5 className="text-center ">Filter</h5>
            <div
              className="pointer"
              onClick={() => {
                setToggle(!toggle);
                setClearFilter(false);
              }}
            >
              <img src={CloseIcon} alt="" />
            </div>
          </div>
          <hr className="mt-0 mb-0" />
          {/* Approval  */}
          <div className="mt-4 ml-1">
            <h4>Approval</h4>
            <div>
              <RadioContainer
                optionsList={APPROVAL_RADIO_OPTIONS}
                handleSetRadioValue={handleSetApprovalRadioValue}
                radioValue={approvalValue}
                alignment="vertical"
              />
            </div>
          </div>
          {/* File Attachment   */}
          <div className="mt-4 ml-1">
            <h4>File Attachments</h4>
            <div>
              <RadioContainer
                optionsList={ATTACHMENT_RADIO_OPTIONS}
                handleSetRadioValue={handleSetAttachmentRadioValue}
                radioValue={attachmentValue}
                alignment="vertical"
              />
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-end p-3 ">
          <button
            className="mr-2 btn btn-outline"
            onClick={() => {
              clearFilter();
              setToggle(!toggle);
            }}
          >
            Clear Filter
          </button>
          <button
            className="btn btn-primary mr-3"
            onClick={() => {
              handleSubmit();
              setToggle(!toggle);
            }}
          >
            Apply
          </button>
        </div>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default DisbursementFilter;
